import { Formik, Form } from 'formik'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Column from '@components/column'
import Row from '@components/row'
import Typography from '@components/typography'
import Fields from '@components/fields'
import { StyleViewBtn } from './style'
import Button from '@components/button'
import { AllPageSchema } from '@validations'
import { GeneralSetting } from '@apis'
import { useSelector } from 'react-redux'
const selectors = {
  'terms-and-conditions': 'termsAndConditions',
  'privacy-and-policy': 'privacyAndPolicy',
  'refund-policy': 'refundPolicy',
}
const AdminAllPagesFormPage = () => {
  const { slug } = useParams()
  const { data: page } = useSelector((state: any) => state[selectors[slug]])
  const initial = {
    value: {
      description: '',
      metaTitle: '',
      metaKeyWords: '',
      metaDescription: '',
    },
    key: slug,
    title: slug.replaceAll('-', ' '),
  }
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    if (page?.id) {
      await GeneralSetting.update({
        id: page?.id,
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: selectors[slug],
      }).catch(() => {})
    } else {
      await GeneralSetting.create({
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: selectors[slug],
      }).catch(() => {})
    }
    setLoading(false)
  }

  const fetchData = async () => {
    await GeneralSetting.getByKey({
      id: slug,
      state: selectors[slug],
    }).catch(() => {})
  }

  useEffect(() => {
    if (page?.id) {
      setInitialValues({
        ...initialValues,
        value: JSON.parse(page?.value),
      })
    } else {
      setInitialValues(initial)
    }
  }, [page?.id])

  useEffect(() => {
    if (!page?.id && !!slug) {
      fetchData()
    }
  }, [slug])
  return (
    <Column rowGap={30}>
      <Column
        bg="secondary"
        styleColumn="padding:20px;border-radius:12px;"
        rowGap={5}
      >
        <Typography
          content={slug.replaceAll('-', ' ')}
          size={16}
          tc="white"
          styleText="text-transform:capitalize;"
        />
        <Row justifyContent="space-between" alignItems="center">
          <Typography
            content={`Write all the content you want to showcase on the ${slug.replaceAll('-', ' ')} page.`}
            size={14}
            tc="white"
          />
          <StyleViewBtn to="/" target="_blank">
            View
          </StyleViewBtn>
        </Row>
      </Column>
      <Column styleColumn="padding:20px;border-radius:12px;" bg="white">
        <Formik
          initialValues={initialValues}
          onSubmit={submitHandler}
          enableReinitialize
          validationSchema={AllPageSchema.validationSchema}
        >
          {({ handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Fields.Editor name="value[description]" />
                  <Fields.Input
                    placeholder="Meta Title"
                    label="Meta Title"
                    name="value[metaTitle]"
                  />
                  <Fields.Input
                    placeholder="Meta Keywords"
                    label="Meta Keywords"
                    name="value[metaKeywords]"
                  />
                  <Fields.TextArea
                    placeholder="Meta Description"
                    label="Meta Description"
                    name="value[metaDescription]"
                    rows={10}
                  />
                  <Column alignItems="flex-end">
                    <Button type="submit" title="Save" loading={loading} />
                  </Column>
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Column>
    </Column>
  )
}

export default AdminAllPagesFormPage
